import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { CsIconModule } from '@components/icon';
import { LanguageBannerContent, LanguageBannerService } from './language-banner.service';

@Component({
  selector: 'app-language-banner',
  templateUrl: './language-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CsIconModule],
})
export class LanguageBannerComponent {
  private readonly languageBannerService = inject(LanguageBannerService);

  readonly content = input.required<LanguageBannerContent>();

  onBannerTap(): void {
    this.languageBannerService.openLanguageSelector(this.content().currentLanguageCode);
  }
}
